import { Navbar } from '#app/components/navbar.tsx'
import { DATA } from '#app/data/portfolio.tsx'
import About from '#app/features/portfolio/sections/about.tsx'
import Contact from '#app/features/portfolio/sections/contact.tsx'
import Experience from '#app/features/portfolio/sections/experience.tsx'
import Hero from '#app/features/portfolio/sections/hero.tsx'
import Projects from '#app/features/portfolio/sections/projects.tsx'
import Settings from '#app/features/portfolio/sections/settings.tsx'
import Writing from '#app/features/portfolio/sections/writing.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	// Deliberately short (Jacob, 2026-08-10): the full name reads long in a tab, and
	// this site is not found through search — links are sent directly.
	{ title: 'Jacob — Full-stack AI engineer' },
	{ name: 'description', content: DATA.metaDescription },
]

export default function Index() {
	return (
		<>
			<main className="font-poppins mx-auto flex w-full max-w-5xl flex-col gap-10 px-4 pt-16 pb-40 sm:px-6 lg:px-8">
				<Hero />
				<About />
				<Experience />
				<Projects />
				<Writing />
				<Contact />
				<Settings />
			</main>
			<Navbar />
		</>
	)
}
